function activateTippable(el) {
  $(el).tooltip();
}

export default activateTippable;
